$(function() {
	$('.days-group li a').on('click', function(){ 
		var pageId = $(this).attr('data-page');
		$('html, body').animate({ scrollTop: $('#'+pageId).offset().top - 223 }, 600);   
	});    
}); 

$(window).scroll(function() {
	var scrollDistance = $(window).scrollTop(); 
	// Assign active class to nav links while scolling
	$('.page-scroll').each(function(i) {
		if ($(this).position().top <= scrollDistance) {
			$('.days-group li a.active').removeClass('active');
			$('.days-group li a').eq(i).addClass('active');
		} 
	});
}).scroll();


$(function() {
    $('.clickToScroll').on('click', function(){ 
        var pageId = $(this).attr('data-page');
        $('html, body').animate({ scrollTop: $('#'+pageId).offset().top - 262 }, 600); 
    });    
});